'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _routeHistory = require('./route-history.js');

var _routeHistory2 = _interopRequireDefault(_routeHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Route = function (_React$Component) {
    _inherits(Route, _React$Component);

    function Route(props) {
        _classCallCheck(this, Route);

        var _this = _possibleConstructorReturn(this, (Route.__proto__ || Object.getPrototypeOf(Route)).call(this, props));

        _this.handleChanging = function () {
            if (typeof _this.props.onChangeStarted === 'function') {
                _this.props.onChangeStarted();
            }
        };

        _this.handleChanged = function (action, route, prevRoute) {
            if (action !== 'none') {
                var component = null;
                if (route && route.match && typeof route.match.render === 'function') {
                    // pull out the parameters from the state
                    var _route$state = route.state,
                        params = _route$state.params,
                        state = _objectWithoutProperties(_route$state, ['params']);

                    component = route.match.render(_extends({}, route.state.props, {
                        route: {
                            params: params,
                            query: route.query,
                            hash: route.hash,
                            state: state
                        }
                    }));
                }

                _this.setState({
                    route: _extends({}, route, { component: component })
                });
            }

            if (typeof _this.props.onChangeEnded === 'function') {
                _this.props.onChangeEnded(action, route, prevRoute);
            }
        };

        _this.state = {
            route: {
                id: 0,
                pathname: '',
                search: '',
                query: {},
                match: null,
                props: {},
                component: null
            }
        };
        return _this;
    }

    _createClass(Route, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _routeHistory2.default.addEventListener('changing', this.handleChanging);
            _routeHistory2.default.addEventListener('changed', this.handleChanged);
            // force a change event to be fired in case this was mounted after
            // the route change
            _routeHistory2.default.refresh(true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _routeHistory2.default.removeEventListener('changing', this.handleChanging);
            _routeHistory2.default.removeEventListener('changed', this.handleChanged);
        }
    }, {
        key: 'render',
        value: function render() {
            if (typeof this.props.render === 'function') {
                return this.props.render(this.state.route);
            } else {
                return null;
            }
        }
    }]);

    return Route;
}(_react2.default.Component);

exports.default = Route;
//# sourceMappingURL=route.js.map